/* eslint-disable indent */
import { KTDom, KTModal } from '@/metronic/core';
import { MODAL_SIZE } from '@/utils/constant.utils';

export const getClassBySize = (size: string) => {
  switch (size) {
    case MODAL_SIZE.SMALL:
      return 'max-w-[400px]';
    case MODAL_SIZE.MEDIUM:
      return 'lg:max-w-[800px]';
    case MODAL_SIZE.LARGE:
      return 'lg:max-w-[1100px]';
  }
  return null;
};

export const showModal = (idModal: string) => {
  const modalEl = KTDom.getElement(idModal);
  const modal = KTModal.getInstance(modalEl);
  modal?.show();
};

export const hideModal = (idModal: string) => {
  const modalEl = KTDom.getElement(idModal);
  const modal = KTModal.getInstance(modalEl);
  modal?.hide();
};
